import * as React from "react";
import { usePanorama } from "@wix/fe-essentials-standalone";

interface ErrorBoundaryProps {
  children: React.ReactNode;
  fallback?: React.ReactNode;
}

interface ErrorBoundaryState {
  hasError: boolean;
}

class ErrorBoundaryInternal extends React.Component<
  ErrorBoundaryProps & { panorama: ReturnType<typeof usePanorama> },
  ErrorBoundaryState
> {
  constructor(
    props: ErrorBoundaryProps & { panorama: ReturnType<typeof usePanorama> },
  ) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error: Error) {
    return { hasError: true };
  }

  componentDidCatch(error: Error, info: React.ErrorInfo) {
    this.props.panorama
      .errorMonitor({
        data: { tags: { feature: "error-boundary" } },
      })
      .reportError(error);
  }

  render() {
    if (this.state.hasError) {
      return this.props.fallback || <></>;
    }

    return this.props.children;
  }
}

export const ErrorBoundary = (props: ErrorBoundaryProps) => {
  const panorama = usePanorama();
  return <ErrorBoundaryInternal {...props} panorama={panorama} />;
};
